import React, { useState, useEffect } from 'react'
import {
    Button,
    ButtonContainer,
    Container,
    ErrorMessage,
    FFile,
    FInput,
    FInputArea,
    FInputWrapper,
    Header,
    Icon,
    ModalContainer,
    ModalContent,
    OverlayLoading,
    Title
} from '../components/tambahTugas'
import { iconClose } from '../../../../assets'
import API from '../../../../config/api';
import swal from 'sweetalert';
import { Loading } from '../../../../components/atoms';
import AddBank from '../../../Employee/Dashboard/EmployeeBank/AddBank';

const ModalCreateUpdateReimbursement = (props) => {
    const { openModal, handlCLose, employee, data, getTicket, setData, setTypeModal, payment, setPayment } = props
    const token = localStorage.getItem('token')
    console.log('data', data)
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const today = new Date().toISOString().split('T')[0];
    const [dateIncurred, setDateIncurred] = useState(today);
    const [type, setType] = useState();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        assign_to: "",
        user_id: employee?.id,
        assign_to: 1
    })

    const [errors, setErrors] = useState({})
    const [images, setImages] = useState([])
    const [amount, setAmount] = useState('');
    const formatRupiah = (value) => {
        const numberString = value.replace(/[^,\d]/g, '');
        const split = numberString.split(',');
        const sisa = split[0].length % 3;
        let rupiah = split[0].substr(0, sisa);
        const ribuan = split[0].substr(sisa).match(/\d{3}/g);

        if (ribuan) {
            rupiah += (sisa ? '.' : '') + ribuan.join('.');
        }

        rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah;
        return rupiah;
    }


    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const onClose = () => {
        handlCLose()
        setFormData({
            title: "",
            description: "",
            assign_to: "",
            user_id: employee?.id,
            assign_to: 1
        })
        setImages([null])
        setData(null)
        setTypeModal()
    }


    const handleImageChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const newImages = [...images];
            newImages[index] = file;

            // Tambah slot baru kalau di index terakhir
            if (index === images.length - 1) {
                newImages.push(null);
            }
            setLoading(true)
            if (data) {
                const img = images[index];
                console.log('newImages[index]', newImages[index], img)
                const payload = new FormData();
                payload.append('files', newImages[index]);

                if (img) {
                    API.editReimbursementAttachment(token, img?.id, payload)
                        .then(res => {
                            setImages(prevImages => {
                                const newItem = { id: res?.data?.data?.id, url: res?.data?.data?.file_url };

                                const exists = prevImages.some(img => img?.id === newItem?.id);

                                if (exists) {
                                    return prevImages.map(img =>
                                        img?.id === newItem?.id ? newItem : img
                                    );
                                } else {
                                    return [...prevImages, newItem];
                                }
                            });
                            setLoading(false)
                            getTicket()
                        })
                        .catch(err => {
                            console.error(err.message);
                            setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                            swal({
                                title: err.response?.status || 'Error',
                                text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                                icon: "error",
                            });
                            setLoading(false)
                        });
                } else {
                    API.addReimbursementAttachment(token, data?.id, payload)
                        .then(res => {
                            const newImage = [...images];
                            newImage[index] = { id: res?.data?.data?.id, url: res?.data?.data?.file_url };
                            if (index === images.length - 1) {
                                newImage.push(null);
                            }
                            setImages(newImage);
                            setMessage('Gambar Berhasil Ditambahkan');
                            swal({
                                title: 'Berhasil',
                                text: `Sub Section Berhasil Ditambah`,
                                icon: "success",
                            });
                            setLoading(false)
                            getTicket()
                        })
                        .catch(err => {
                            console.error(err.message);
                            setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                            swal({
                                title: err.response?.status || 'Error',
                                text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                                icon: "error",
                            });
                            setLoading(false)
                        });
                }
            } else {
                const newImage = [...images];
                newImage[index] = file;

                // Tambah slot baru kalau di index terakhir
                if (index === images.length - 1) {
                    newImage.push(null);
                }

                setImages(newImage)
                setLoading(false)

            }
        }
    };

    const validate = () => {
        const newErrors = {}
        if (!formData.title) newErrors.title = "Title wajib diisi"
        if (!formData.description) newErrors.description = "Deskripsi wajib diisi"
        if (!amount) newErrors.amount = "Nominal wajib diisi"
        if (!dateIncurred) newErrors.date_incurred = "Tangal pengeluaran wajib diisi"
        return newErrors
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setLoading(true)
            const payload = new FormData();
            payload.append('title', formData.title);
            payload.append('description', formData.description);
            payload.append('amount', amount.replace(/\./g, ''));
            payload.append('date_incurred', dateIncurred);

            // Hanya File yang di-upload
            images.filter(img => img instanceof File).forEach((file, i) => {
                payload.append(`files[${i}]`, file);
            });

            if (data) {
                payload.append('status', formData.status === 'canceled' ? formData.status : "pending");
                API.editReimbursement(token, data?.id, payload)
                    .then(res => {
                        setMessage('Data Reimbursement Berhasil Diupdate');
                        swal({
                            title: 'Berhasil',
                            text: `Sub Section Berhasil Ditambah`,
                            icon: "success",
                        });
                        setLoading(false)
                        handlCLose()
                        setFormData({
                            title: "",
                            description: "",
                            user_id: employee?.id,
                        })
                        setDateIncurred();
                        setAmount()
                        setImages([])
                        setData(null)
                        getTicket()
                    })
                    .catch(err => {
                        console.error(err.message);
                        setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                        swal({
                            title: err.response?.status || 'Error',
                            text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                            icon: "error",
                        });
                        setLoading(false)
                        handlCLose()
                    });
            } else {
                API.addReimbursement(token, payload, employee?.id)
                    .then(res => {
                        setMessage('Data Reimbursement Berhasil Ditambahkan');
                        swal({
                            title: 'Berhasil',
                            text: `Reimbursement Berhasil Ditambah`,
                            icon: "success",
                        });
                        setLoading(false)
                        handlCLose()
                        handlCLose()
                        setFormData({
                            title: "",
                            description: "",
                            user_id: employee?.id,
                        })
                        setDateIncurred();
                        setAmount()
                        setImages([])
                        setData(null)
                        getTicket()
                    })
                    .catch(err => {
                        console.error(err.message);
                        setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                        swal({
                            title: err.response?.status || 'Error',
                            text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                            icon: "error",
                        });
                        setLoading(false)
                        handlCLose()
                    });

            }

        }
    };
    const handleSubmitBank = (data) => {
        const payload = new FormData();
        payload.append('bank_name', data.bank_name);
        payload.append('bank_branch', data.bank_branch);
        payload.append('name', data.name);
        payload.append('number', data.number);

        API.addEmployeeAccountBank(token, payload, employee?.id)
            .then(res => {
                setMessage('Data Pemabyaran Berhasil Ditambahkan');
                swal({
                    title: 'Berhasil',
                    text: `Pemabyaran Berhasil Ditambah`,
                    icon: "success",
                });
                setPayment(true)
                setLoading(false)
            })
            .catch(err => {
                console.error(err.message);
                setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                swal({
                    title: err.response?.status || 'Error',
                    text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                    icon: "error",
                });
                setLoading(false)
                handlCLose()
            });
    };
    useEffect(() => {
        if (openModal) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('hide-scrollbar');

            return () => {
                document.body.style.overflow = '';
                document.body.classList.remove('hide-scrollbar');
            };
        }
    }, [openModal])

    useEffect(() => {
        if (openModal && images.length === 0) {
            setImages([null])
        }
    }, [openModal])

    const handleRemoveImage = (index) => {
        if (type === 'update') {
            const img = images[index];
            setLoading(true)
            // Cek apakah img adalah dari backend (objek dengan id dan url)
            if (data) {
                if (img && typeof img === 'object' && img.id) {
                    API.deleteReimbursementAttachment(token, img.id).then(res => {
                        // console.log(res)
                        // console.log('oke')
                        const newImages = [...images];
                        newImages.splice(index, 1);

                        if (newImages.length === 0 || newImages[newImages.length - 1] !== null) {
                            newImages.push(null);
                        }

                        setImages(newImages);
                        swal({
                            title: 'Berhasil',
                            text: res.message,
                            icon: "success",
                        });
                        setLoading(false)
                        getTicket()
                    })

                    // Di sini bisa kamu push ke array deletedImageId kalau mau hapus di backend nanti
                    // contoh: setDeletedImages(prev => [...prev, img.id]);
                }
            }
        } else {
            const newImages = [...images];
            newImages.splice(index, 1);

            // Jika tidak ada input kosong di akhir, tambahkan kembali
            if (newImages.length === 0 || newImages[newImages.length - 1] !== null) {
                newImages.push(null);
            }

            setImages(newImages);
        }
    };
    useEffect(() => {
        if (data) {
            setType('update')
            const numericString = data?.amount.replace('Rp ', '').replace(',', '');

            // Mengonversi ke integer
            const intValue = parseInt(numericString, 10);
            const formatted = intValue.toLocaleString('id-ID');
            setAmount(formatted);
            setDateIncurred(data?.date_incurred);
            setFormData(prev => ({
                ...prev,
                title: data?.title || '',
                description: data?.description || '',
            }));

            if (data.attachments && Array.isArray(data.attachments)) {
                const imageData = data.attachments.map(item => ({
                    id: item.id,
                    url: item.file_url
                }));
                setImages([...imageData, null]); // Tambahkan slot kosong
            } else {
                setImages([null]);
            }
        }
    }, [data]);



    return (
        openModal && (
            <ModalContainer>
                <Container>
                    <ModalContent>
                        <Header>
                            <Title>{data ? "Edit" : "Tambah"}{payment ? "Data Reimbursement" : "Data pembayaran"}</Title>
                            <Icon src={iconClose} onClick={onClose} />
                        </Header>

                        {
                            payment ?
                                <form onSubmit={handleSubmit}>
                                    <FInputWrapper>
                                        <FInput
                                            name="title"
                                            placeholder="Pengganti biaya untuk..."
                                            value={formData.title}
                                            onChange={handleChange}
                                        />
                                        {errors.title && <ErrorMessage>{errors.title}</ErrorMessage>}
                                    </FInputWrapper>

                                    <FInputWrapper>
                                        <FInputArea
                                            name="description"
                                            placeholder="Keterangan pengganti biaya..."
                                            value={formData.description}
                                            onChange={handleChange}
                                        />
                                        {errors.description && <ErrorMessage>{errors.description}</ErrorMessage>}
                                    </FInputWrapper>
                                    <FInputWrapper>
                                        <div style={{ position: 'relative' }}>
                                            <span style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#999',
                                                marginTop: "-3px",
                                                fontSize: "14px"
                                            }}>Rp.</span>
                                            <FInput
                                                name="amount"
                                                placeholder="Nominal"
                                                value={amount}
                                                onChange={(e) => setAmount(formatRupiah(e.target.value))}
                                                style={{ paddingLeft: '35px', width: '96%' }}
                                            />
                                        </div>
                                        {errors.amount && <ErrorMessage>{errors.amount}</ErrorMessage>}
                                    </FInputWrapper>
                                    <FInputWrapper>
                                        <label>Tanggal Pengeluaran</label>
                                        <FInput
                                            type="date"
                                            name="date_incurred"
                                            value={dateIncurred}
                                            onChange={(e) => setDateIncurred(e.target.value)}
                                            className='unstyled'
                                        />
                                        {errors.date_incurred && <ErrorMessage>{errors.date_incurred}</ErrorMessage>}
                                    </FInputWrapper>
                                    {
                                        data &&
                                        <FInputWrapper>
                                            <label htmlFor="status">Status</label>
                                            <select
                                                id="status"
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                                style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                                            >
                                                <option value="">Pending</option>
                                                <option value="canceled">Canceled</option>
                                            </select>
                                            {errors.status && <ErrorMessage>{errors.status}</ErrorMessage>}
                                        </FInputWrapper>

                                    }

                                    {/* Upload Gambar */}
                                    {images.map((img, index) => (
                                        <FInputWrapper key={index} style={{ position: 'relative', width: '90%', display: "flex", justifyContent: "left", alignItems: "center" }}>
                                            <FFile
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, index)}
                                                id={`imageInput-${index}`}
                                            />
                                            <label
                                                htmlFor={`imageInput-${index}`}
                                                style={{
                                                    border: '1px dashed #ccc',
                                                    padding: '10px',
                                                    display: 'flex',
                                                    cursor: 'pointer',
                                                    minHeight: '100px',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: "250px",
                                                    position: 'relative'
                                                }}
                                            >
                                                {img ? (
                                                    // Tampilkan File atau Gambar dari Backend
                                                    img instanceof File
                                                        ? <img src={URL.createObjectURL(img)} alt={`Preview-${index}`} style={{ maxWidth: '100%', maxHeight: '150px' }} />
                                                        : <img src={img.url} alt={`Preview-${index}`} style={{ maxWidth: '100%', maxHeight: '150px' }} />
                                                ) : (
                                                    'Tambah bukti pembayaran'
                                                )}
                                            </label>
                                            {img && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveImage(index)}
                                                    style={{
                                                        top: 0,
                                                        right: 0,
                                                        background: 'red',
                                                        color: '#fff',
                                                        border: 'none',
                                                        cursor: 'pointer'
                                                    }}
                                                    title="Hapus Gambar"
                                                >
                                                    Hapus
                                                </button>
                                            )}
                                        </FInputWrapper>
                                    ))}


                                    <ButtonContainer style={{ marginBottom: "150px" }}>
                                        <Button type="submit">Simpan</Button>
                                    </ButtonContainer>
                                </form>
                                :
                                <AddBank handleSubmitBank={handleSubmitBank} />
                        }
                    </ModalContent>
                    <OverlayLoading loading={loading}>
                        {loading && <Loading />}
                    </OverlayLoading>
                </Container>
            </ModalContainer>
        )
    )
}

export default ModalCreateUpdateReimbursement
